import { render } from "./intake_form_app.vue?vue&type=template&id=6476e4cb"
import script from "./intake_form_app.vue?vue&type=script&lang=js"
export * from "./intake_form_app.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__